import { queryOrderPayment } from "@/api/order";

function formatPaymentTime(value) {
  if (!value) {
    return "未返回";
  }
  const text = String(value);
  if (!/^\d{14}$/.test(text)) {
    return text;
  }
  const date = [text.slice(0, 4), text.slice(4, 6), text.slice(6, 8)];
  const time = [text.slice(8, 10), text.slice(10, 12), text.slice(12, 14)];
  return `${date.join("-")} ${time.join(":")}`;
}

export const orderPaymentQueryMixin = {
  data() {
    return {
      paymentQueryLoadingId: null,
    };
  },
  methods: {
    async handleQueryOrderPayment(order) {
      // 同一页面一次只查询一笔，避免连续点击重复向上游发送查单请求。
      if (this.paymentQueryLoadingId !== null) {
        return;
      }
      if (!order || order.status !== 4) {
        this.$message.warning("仅支持查询支付中的订单，请刷新列表后重试");
        return;
      }
      if (!order.id || !order.orderNo) {
        this.$message.warning("订单信息不完整，请刷新列表后重试");
        return;
      }

      this.paymentQueryLoadingId = order.id;
      try {
        const response = await queryOrderPayment(order.id, order.orderNo);
        const result = response.data;
        if (!result || String(result.retCode) !== "0" || !result.retData) {
          throw new Error((result && result.retMsg) || "未取得有效支付结果");
        }

        // retCode=0 只代表查单成功，不能据此把失败或未知流水显示为已付款。
        const payStatus = String(result.retData.pay_status);
        const paymentStates = {
          0: { text: "支付成功", type: "success" },
          1: { text: "支付失败", type: "warning" },
          2: { text: "支付结果待确认", type: "warning" },
          11: { text: "已退款", type: "info" },
        };
        let paymentState = {
          text: "支付结果待确认（未识别的支付状态）",
          type: "warning",
        };
        if (Object.prototype.hasOwnProperty.call(paymentStates, payStatus)) {
          paymentState = paymentStates[payStatus];
        }
        const details = [
          `订单号：${response.orderNo}`,
          `支付流水：${response.payId}`,
          `支付状态：${paymentState.text}`,
          `支付时间：${formatPaymentTime(result.retData.pay_time)}`,
        ];
        if (payStatus === "11") {
          const refundTime = formatPaymentTime(result.retData.refund_time);
          details.push(`退款时间：${refundTime}`);
        }
        details.push("列表将自动刷新，订单状态同步可能稍有延迟。");

        // 使用文本节点显示银行返回值，不把订单或流水拼成 HTML。
        const createElement = this.$createElement;
        const paragraphStyle = { wordBreak: "break-all" };
        const message = createElement(
          "div",
          details.map((text) => {
            return createElement("p", { style: paragraphStyle }, text);
          })
        );
        this.$alert(message, "订单支付状态", {
          confirmButtonText: "关闭",
          type: paymentState.type,
        }).catch(() => {
          // 关闭结果弹窗不代表支付查询失败。
        });
      } catch (error) {
        // 超时、网络异常或查单错误仅提示查询失败，不修改订单为支付成功或失败。
        const message = error.message || "请稍后重试";
        this.$message.error(`支付状态查询失败：${message}`);
      } finally {
        try {
          // 即使查单超时，上游仍可能已同步结果；始终重新读取后台列表，不在前端改订单状态。
          await this.query();
        } finally {
          this.paymentQueryLoadingId = null;
        }
      }
    },
  },
};
